import SvgIcon from '@material-ui/core/SvgIcon';
import React from 'react';

const ExcelIcon = ({ className }) => (
  /* eslint max-len: ["error", { "ignoreStrings": true }] */
  <SvgIcon viewBox='0 0 24.929 23.601' className={className}>
    <defs>
      <radialGradient
        id='radial-gradient'
        cx='6.02'
        cy='25.157'
        r='0.39'
        gradientTransform='translate(-3.837 -22.366) scale(1.661 1.921)'
        gradientUnits='objectBoundingBox'
      >
        <stop offset='0' stopColor='#237f4c' />
        <stop offset='1' stopColor='#1e6c41' />
      </radialGradient>
    </defs>
    <rect id='rect4556' width='23.35' height='18.313' rx='3.375' transform='translate(1.23 2.582)' fill='#fff' />
    <g id='use3985' transform='translate(13.449 2.344)'>
      <path
        id='rect3991'
        d='M103.389-46.454h3.983v2.046h-3.983Zm4.8,0h3.983v2.042h-3.983Zm-4.8-2.966h3.983v2.144h-3.983Zm4.8,0h3.983v2.144h-3.983Zm-4.8-2.961h3.983v2.144h-3.983Zm4.8,0h3.983v2.144h-3.983Zm-4.8-2.961h3.983V-53.2h-3.983Zm4.8,0h3.983V-53.2h-3.983Zm-4.8-2.961h3.983v2.144h-3.983Zm4.8,0h3.983v2.144h-3.983Zm-4.938-2.447v.813h10.658v17.262H103.25v.817h10.59a.889.889,0,0,0,.889-.889V-59.862a.889.889,0,0,0-.889-.889H103.25Z'
        transform='translate(-103.25 60.751)'
        fill='#1f7144'
      />
    </g>
    <path
      id='path3945'
      d='M18.68,9.063,4.469,11.59V30.1l14.2,2.566Zm-4.544,7.616L12.1,20.861l2.089,4.208L12.3,24.958l-1.242-3.08-1.217,2.94-1.664-.094,1.953-3.863L8.277,16.955l1.8-.085,1.047,2.846,1.259-2.957Z'
      transform='translate(-4.469 -9.063)'
      fill='url(#radial-gradient)'
    />
  </SvgIcon>
);

export default ExcelIcon;
